import React, { useState, useEffect } from "react";

const PyqSubjects = ({
  removeSelectedPrompt,
  data,
  handleTopicSelectPyq,
  handlecutomSelect,
}) => {
  const [selectedSubject, setSelectedSubject] = useState("");
  const [selectedTopic, setSelectedTopic] = useState("");

  useEffect(() => {
    handleTopicSelectPyq(selectedSubject, selectedTopic);
  }, [selectedTopic, selectedSubject]);

  const handleSubjectSelect = (subject) => {
    setSelectedSubject(subject);
    setSelectedTopic(""); // Reset topic selection when subject changes
  };

  const handleTopicSelect = (topic) => {
    setSelectedTopic(topic);
  };

  return (
    <div className="">
      <div id="">
        {/* Select Subject Section */}
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              textAlign: "center",
            }}
          >
            <img
              src="/assets/images/new-arrow.svg"
              alt="Logo"
              style={{ marginLeft: "10px" }}
            />
            <span
              style={{
                marginLeft: "10px",
                fontFamily: '"Source Sans 3", sans-serif',
                fontWeight: 500,
                fontSize: "13px",
                lineHeight: 1,
                letterSpacing: 0,
                color: "#49546C"
              }}
            >
              PYQ Mains
            </span>
          </div>
          <div>
            <img
              src="/assets/images/new-close.svg"
              alt="Logo"
              style={{ marginRight: "6px" }}
              onClick={removeSelectedPrompt}
            />
          </div>
        </div>

        <p className="select-text">Select Subject</p>
        <div className="oval-container" id="subjectContainer">
          {data.subjects.map((subject) => (
            <div
              key={subject.value}
              className={`oval selectable ${
                selectedSubject === subject.value ? "selected" : ""
              }`}
              role="button"
              tabIndex="0"
              data-selected={selectedSubject === subject.value}
              onClick={() => {
                handleTopicSelectPyq(subject.value, selectedTopic);
                handleSubjectSelect(subject.value);
              }}
            >
              {subject.label}
            </div>
          ))}
        </div>

        {/* Select Topic Section */}
        {selectedSubject && (
          <div id="subjectTopicContainer">
            <p className="select-text">Select Topic</p>
            <div className="oval-container">
              {(data.topics[selectedSubject] || []).map((topic) => (
                <div
                  key={topic.value}
                  className={`oval selectable ${
                    selectedTopic === topic.value ? "selected" : ""
                  }`}
                  role="button"
                  tabIndex="0"
                  data-selected={selectedTopic === topic.value}
                  onClick={() => {
                    handleTopicSelectPyq(selectedSubject, topic.value);
                    handleTopicSelect(topic.value);
                  }}
                >
                  {topic.label}
                </div>
              ))}
              <div
                className="custom-button"
                onClick={() => {
                  handlecutomSelect();
                  handleTopicSelectPyq(selectedSubject, "");
                }}
              >
                Custom
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default PyqSubjects;
